export default "__VITE_ASSET__DufGo4xU__"